import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class PianiTerapeuticiService {

    constructor() { }

    piani_terapeutici: Array<any> = [];
    async list(index: number) {
        this.piani_terapeutici = [
            {
                "Id": 1,
                "Patient": "Mario Rossi",
                "Diagnosis": "Mano Rotta",
                "Date_From": "2025-05-01",
                "Date_To": "2025-06-15",
                "HasPharmacy": true,
                "Alert": 0
            },
            {
                "Id": 2,
                "Patient": "Giovanni Verdi",
                "Diagnosis": "Ipertensione",
                "Date_From": "2025-05-01",
                "Date_To": "2025-11-01",
                "HasPharmacy": false,
                "Alert": 0
            },
            {
                "Id": 3,
                "Patient": "Luca Bianchi",
                "Diagnosis": "Disturbo bipolare",
                "Date_From": "2025-04-01",
                "Date_To": "2025-10-01",
                "HasPharmacy": true,
                "Alert": 5
            },
        ];


        await new Promise(resolve => setTimeout(resolve, 1000));
        let piani_terapeutici = this.piani_terapeutici.slice(index, index + 20);
        return piani_terapeutici;
    }
}
